import DohukMap from './DohukMap';
import MapComponent from './MapComponent';
import { FaWhatsapp, FaPhoneAlt, FaEnvelope, FaRegCheckCircle, FaMapMarkerAlt } from 'react-icons/fa';
const locations = [
    { name: 'Point A', latitude: 51.505, longitude: -0.09 },
    { name: 'Point B', latitude: 51.515, longitude: -0.1 },
];
const Dohuk = () =>{
    return(
        <section id="map" className=" myMap map features">
                <h2 className="features-heading"> <span>:</span>تتوفر عدساتنا في المتاجر التالية </h2>
                <div className="feature-cards">
                  {[
                   
                    { title: 'مجمع دارا الطبي', desc: 'دهوك - دوميز - الدورة الثانية ', }

                  ].map((feature, index) => (
                    <div key={index} className={`dark-cards feature-card ${feature.side}`}>
                      <h4><FaMapMarkerAlt className="check-icon" size={20} />
        {feature.title}             
        </h4>
                      <p>{feature.desc}</p>
                    </div>
                  ))}
        
        </div>
        
                <DohukMap locations={locations} />
        </section>
    )
}

export default Dohuk


